module.exports = __webpack_public_path__ + "media/images/confetti-left-adee6115.svg";